// extracted by mini-css-extract-plugin
module.exports = {"root":"root-3eVaSrhiwO","centered":"centered-3gjbiRW3yj"};